import React from "react";
import { usePermissionTabs } from "../../../hooks/usePermissionTabs";
import { PermissionTabManager } from "../../../components/PermissionTabManager";
import LineHaulCompanies from "./LineHaulCompanies";
import RequestsCompanies from "./RequestsCompanies";
import { useSearchParams } from "react-router-dom";
import RoleToggle from "../../../components/RoleToggle";

const ALL_TABS = [
  {
    key: "Company",
    label: "Company",
    component: <LineHaulCompanies activeRole="Company" />,
    modules: ["line_haul"],
    operation: "read",
  },
  {
    key: "Requests",
    label: "Request",
    component: <RequestsCompanies activeRole="Requests" />,
    modules: ["line_haul_request"],
    operation: "read",
  },
];

interface LineHaulProps {
  setHeaderActions?: (node: React.ReactNode) => void;
  setHeaderButtons?: (node: React.ReactNode) => void;
}

const LineHaul: React.FC<LineHaulProps> = ({ setHeaderActions, setHeaderButtons }) => {
  const [subHeaderButtons, setSubHeaderButtons] =
    React.useState<React.ReactNode>(null);
  const result = usePermissionTabs({
    tabs: ALL_TABS,
    param: "sub",
    parentTab: "Line Haul",
  });

  const clonedContent =
    result.content && React.isValidElement(result.content)
      ? React.cloneElement(
          result.content as React.ReactElement,
          {
            setHeaderActions,
            setHeaderButtons: setSubHeaderButtons,
          } as any,
        )
      : result.content;

  React.useEffect(() => {
    if (setHeaderButtons && result.visibleTabs.length > 0) {
      setHeaderButtons(
        <RoleToggle
          options={result.visibleTabs.map((t) => t.label)}
          active={result.activeLabel}
          onChange={result.handleChange}
          activeClassName="bg-[#FBD037] text-[#131327] font-bold shadow-sm"
        />
      );
    }
    return () => {
      if (setHeaderButtons) {
        setHeaderButtons(null);
      }
    };
  }, [setHeaderButtons, result.activeLabel, result.visibleTabs]);

  return (
    <>
      <PermissionTabManager
        visibleTabs={result.visibleTabs}
        activeLabel={result.activeLabel}
        content={clonedContent}
        isLoading={result.isLoading}
        error={result.error}
        className="relative bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl transition-all duration-300 w-full rounded-none"
        subClassName=""
        contentClassName="px-4 pb-4 pt-2 sm:px-6 sm:pb-6 sm:pt-2"
        handleChange={result.handleChange}
        tabPosition="right"
        hideToggle={true}
        // headerButtons={subHeaderButtons}
      />
    </>
  );
};

export default LineHaul;
